/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

export const attendancesKeys = {
  /** Every attendance query of an agency — what a refresh invalidates. */
  all: (agencyId: string) => ['attendances', agencyId] as const,
  /**
   * One board column's page.
   *
   * The board queries per column now, so the key carries the column and
   * the page: a single key for all five would make loading more in one
   * column discard the other four.
   *
   * Every filter the server sees is part of the key. `stages` is included
   * because the stage filter narrows a column's stages, so two different
   * selections are two different questions — sharing a key between them
   * would serve one selection's cards under the other's filter.
   */
  column: (
    agencyId: string,
    columnId: string,
    filters: {
      originChannel?: string;
      stages?: readonly string[];
      brokerId?: string;
    },
    page: number,
  ) => [
    'attendances',
    agencyId,
    'column',
    columnId,
    filters.originChannel ?? '',
    [...(filters.stages ?? [])].join(','),
    filters.brokerId ?? '',
    page,
  ] as const,
};
